module.exports = __webpack_public_path__ + "static/font-6493b4a772f9ca0e3a0fe186e6ec5f90.woff2";